/** @jsxImportSource @emotion/react */

import type {AccordionItemProps as LibAccordionItemProps} from "@szhsin/react-accordion";
import {AccordionItem as Item} from "@szhsin/react-accordion";
import type {ReactNode} from "react";
import expandMore from "@/assets/icons/interface/expandMore.svg";
import Markdown from "@/elements/Markdown";
import {
  AccordionItemContent,
  AccordionItemHeader,
  accordionItemCss,
  Emoji,
  HeaderTextWrapper,
  TextWrapper,
} from "./styles";

interface AccordionItemProps extends Omit<LibAccordionItemProps, "header"> {
  styles?: {border?: string};
  showIcon?: boolean;
  header?: ReactNode;
}

export const AccordionItem = ({
  styles,
  showIcon = true,
  header,
  ...rest
}: AccordionItemProps) => {
  return (
    <Item
      {...rest}
      css={() => accordionItemCss(styles)}
      header={
        <>
          {header}
          {showIcon && <img className="expand-more" src={expandMore} alt="Expand" />}
        </>
      }
    />
  );
};

interface AccordionHeaderProps {
  emoji?: ReactNode;
  title?: string;
}

export const AccordionHeader = ({emoji, title}: AccordionHeaderProps) => {
  return (
    <AccordionItemHeader>
      <HeaderTextWrapper>
        <Emoji>{emoji}</Emoji>
        <Markdown styles={{fontWeight: 700, color: "#1D3140"}}>{title}</Markdown>
      </HeaderTextWrapper>
    </AccordionItemHeader>
  );
};

interface AccordionContentProps {
  content?: string;
}

export const AccordionContent = ({content}: AccordionContentProps) => {
  return (
    <AccordionItemContent>
      <TextWrapper>
        <Markdown styles={{color: "#1D3140"}}>{content}</Markdown>
      </TextWrapper>
    </AccordionItemContent>
  );
};
